import React from 'react';

import useGetRequest from 'src/hooks/useGetRequest';
import CRUDConfigForm from 'src/components/formik/CRUDConfigForm';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import Card from 'src/components/Card';
import FormikSelect from 'src/components/formik/FormikSelect';
import { getUserOptions } from 'src/views/shared/rolesConfig';
import { Account } from 'src/types';
import Button from '../../../../../components/Button';

interface Props {
  onSuccess?: () => void,
  engagementId: string,
  workflowId: string,
  submitMethodOverride: 'post' | 'patch',
  cancelEdit: () => void,
}

function RoleAssignmentsForm({
  onSuccess,
  engagementId,
  workflowId,
  submitMethodOverride,
  cancelEdit,
}: Props) {
  const { result: contacts, isLoading: contactsLoading } = useGetRequest({
    url: '/automatic/contacts/',
    initialResult: [],
  });

  const { result: roleAssignments, isLoading: roleAssignmentsLoading } = useGetRequest({
    url: `/automatic/engagements/${engagementId}/role-assignments/`,
    initialResult: [],
  });

  const { result: roles, isLoading: rolesLoading } = useGetRequest({
    url: `/automatic/workflows/${workflowId}/roles/`,
    initialResult: [],
  });

  const accountIdByRoleId: Record<string, Account> = {};
  roleAssignments.forEach((assignment: any) => {
    accountIdByRoleId[assignment.role.id] = assignment.account.id;
  });

  const fields = [
    {
      isArray: true,
      noFieldGrid: true,
      name: 'roleAssignments',
      component: (children: any) => (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                Role
              </TableCell>
              <TableCell>
                User
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {children}
          </TableBody>
        </Table>
      ),
      fields: () => roles.reduce((acc: any, role: any, index: any) => acc.concat([
        {
          noGrid: true,
          noFieldGrid: true,
          fields: [
            {
              name: 'accountId',
              component: () => (
                <TableRow>
                  <TableCell>{role.name}</TableCell>
                  <TableCell>
                    <FormikSelect
                      id={`select-role-${role.id}`}
                      fullWidth
                      name={`roleAssignments[${index}].accountId`}
                      options={getUserOptions(contacts)}
                    />
                  </TableCell>
                </TableRow>
              ),
              // validator: Yup.string().required('This field is required.'),
              defaultValue: accountIdByRoleId[role.id]
            },
            {
              name: 'roleId',
              defaultValue: role.id,
            }
          ]
        }
      ]), []),
    }
  ];

  const cancelEditButton = (
    <Button onClick={cancelEdit}>
      Cancel
    </Button>
  );

  return (
    <Card title="Role assignments" p={1} action={cancelEditButton}>
      <CRUDConfigForm
        url={`/automatic/engagements/${engagementId}/role-assignments/`}
        submitMethodOverride={submitMethodOverride}
        onSuccess={onSuccess}
        fieldsConfig={fields}
        includeDeleteButton
      />
    </Card>
  );
}

export default RoleAssignmentsForm;
